import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Popover,
  type PopoverOrigin,
} from '@mui/material';
import { vars } from '@tgtg/kit';
import { NavLink } from 'react-router';

import type { ReactNode } from 'react';

export type NavPopoverItem = {
  id: string;
  to: string;
  label: ReactNode;
  icon: ReactNode;
  isActive?: boolean;
};

type NavPopoverProps = {
  items: NavPopoverItem[];
  anchorEl: HTMLElement | null;
  isOpen: boolean;
  onClose: VoidFunction;
  anchorOrigin: PopoverOrigin;
  transformOrigin: PopoverOrigin;
};

const NavPopover = ({
  items,
  anchorEl,
  isOpen,
  onClose,
  anchorOrigin,
  transformOrigin,
}: NavPopoverProps) => {
  return (
    <Popover
      open={isOpen}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      slotProps={{
        paper: {
          sx: {
            borderRadius: vars.radius.medium,
            boxShadow: vars.elevation.regular,
            minWidth: anchorEl?.offsetWidth,
          },
        },
      }}
    >
      <List disablePadding>
        {items.map(({ id, to, label, icon, isActive }) => (
          <ListItem key={id} disablePadding>
            <ListItemButton
              component={NavLink}
              to={to}
              onClick={onClose}
              sx={{
                paddingX: vars.spacing.neutral.xlarge,
                paddingY: vars.spacing.neutral.large,
                color: isActive ? vars.color.content.brand : 'inherit',
              }}
            >
              <ListItemIcon sx={{ minWidth: `calc(18px + ${vars.spacing.neutral.large})` }}>
                {icon}
              </ListItemIcon>
              <ListItemText
                primary={label}
                primaryTypographyProps={{
                  fontWeight: 500,
                  fontFamily: vars.typography.labels.medium.fontFamily,
                  fontSize: vars.typography.labels.medium.fontSize,
                }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Popover>
  );
};

export default NavPopover;
